export default "__VITE_ASSET__D6QbPHc___"